export type NavItem = {
  label: string;
  href?: string;
  children?: NavItem[];
};

export const navigation: NavItem[] = [
  {
    label: "Solutions",
    children: [
      {
        label: "Data Audit",
        href: "https://intellica.co.uk/solutions/data-audit",
      },
      {
        label: "Scheme Proforma",
        href: "https://intellica.co.uk/solutions/scheme-proforma",
      },
      {
        label: "Calculation Specification",
        href: "https://intellica.co.uk/solutions/calculation-specification",
      },
      {
        label: "De-risking",
        href: "https://intellica.co.uk/solutions/derisking",
      },
      {
        label: "Calculation Solutions",
        href: "https://intellica.co.uk/solutions/calculation-solutions",
      },
      {
        label: "Data Migration",
        href: "https://intellica.co.uk/solutions/data-migration",
      },
      {
        label: "Data Resolution",
        href: "https://intellica.co.uk/solutions/data-resolution",
      },
      {
        label: "Pension Dashboards",
        href: "https://intellica.co.uk/solutions/pension-dashboards",
      },
      {
        label: "Specialist Support",
        href: "https://intellica.co.uk/solutions/specialist-support",
      },
    ],
  },
  {
    label: "Capabilities",
    children: [
      {
        label: "Constellation",
        href: "https://intellica.co.uk/capabilities/constellation/",
      },
      {
        label: "Cosan Consulting",
        href: "https://intellica.co.uk/capabilities/cosan-consulting/",
      },
    ],
  },
  {
    label: "Explore",
    children: [
      {
        label: "News",
        href: "https://intellica.co.uk/explore?filter=news",
      },
      {
        label: "Case Studies",
        href: "https://intellica.co.uk/explore?filter=case-study",
      },
      {
        label: "Insights",
        href: "https://intellica.co.uk/explore?filter=insight",
      },
      {
        label: "Documents",
        href: "https://intellica.co.uk/explore?filter=document",
      },
    ],
  },
  {
    label: "About",
    children: [
      {
        label: "Our Story",
        href: "https://intellica.co.uk/about/our-story",
      },
      {
        label: "Meet the Team",
        href: "https://intellica.co.uk/about/our-story#meet-the-team",
      },
      {
        label: "Careers at Intellica",
        href: "https://intellica.co.uk/about/careers/",
      },
    ],
  },
  {
    label: "Contact",
    href: "https://www.intellica.co.uk/contact",
  },
];